import Phaser from 'phaser';

export default class PermadeathScene extends Phaser.Scene {
  constructor(config: Phaser.Types.Scenes.SettingsConfig = {}) {
    super({
      key: 'permadeath',
      ...config,
    });
  }

  update() {}
}
